import { render, staticRenderFns } from "./DescargaMasvia.vue?vue&type=template&id=6ff884fc"
import script from "./DescargaMasvia.vue?vue&type=script&lang=js"
export * from "./DescargaMasvia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports